// removed by extract-text-webpack-plugin
module.exports = {"bannerContainer":"bannerContainer___22FuK","bannerCategoriesWrapper":"bannerCategoriesWrapper___2uZNe","categoryButtonContainer":"categoryButtonContainer___32znI"};